var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOval31A = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 49",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M0 35c0-7.732 6.268-14 14-14h32c7.732 0 14 6.268 14 14s-6.268 14-14 14H14C6.268 49 0 42.732 0 35ZM20.666 13.5a2.5 2.5 0 0 1-2.5 2.5H6.5A2.5 2.5 0 0 1 4 13.5v-10A2.5 2.5 0 0 1 6.5 1h14.166v12.5ZM38.334 13.5a2.5 2.5 0 0 1-2.5 2.5H24.166a2.5 2.5 0 0 1-2.5-2.5V1h16.666v12.5ZM56 13.5a2.5 2.5 0 0 1-2.5 2.5H41.833a2.5 2.5 0 0 1-2.5-2.5V1H53.5A2.5 2.5 0 0 1 56 3.5v10Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M4 12a1 1 0 0 1-1-1V3.5A3.5 3.5 0 0 1 6.5 0h47A3.5 3.5 0 0 1 57 3.5V11a1 1 0 1 1-2 0V3.5A1.5 1.5 0 0 0 53.5 2h-47A1.5 1.5 0 0 0 5 3.5V11a1 1 0 0 1-1 1Z",
  clipRule: "evenodd"
})));
SvgOval31A.viewBox = '0 0 60 49';
const ForwardRef = /*#__PURE__*/forwardRef(SvgOval31A);
export default ForwardRef;